import { z } from 'zod';
import { dateLike, zeroOrOneLike } from '@/schemas/field-schemas';

// Update the filter schema to use Vietnamese snake_case keys
export const searchSchema = z.object({
  ngay_ct1: dateLike,
  ngay_ct2: dateLike,
  ma_nt: z.string().nullable().optional(),
  tk_co: z.string().nullable().optional(),
  ma_kh: z.string().nullable().optional(),
  nh_kh1: z.string().nullable().optional(),
  nh_kh2: z.string().nullable().optional(),
  nh_kh3: z.string().nullable().optional(),
  unit_id: z.string().nullable().optional(),
  pb_yn: z.coerce.number().int().min(0).max(2),
  xu_ly: z.coerce.number().int().min(0).max(2),
  xl_pb_yn: zeroOrOneLike
});

// Update the initial values to match the Vietnamese snake_case keys
export const initialValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  ma_nt: null,
  tk_co: null,
  ma_kh: null,
  nh_kh1: null,
  nh_kh2: null,
  nh_kh3: null,
  unit_id: null,
  pb_yn: 0,
  xu_ly: 0,
  xl_pb_yn: 0
};

export type SearchFormValues = z.infer<typeof searchSchema>;
